import { uniqueId } from "lodash";
import React, { useState } from "react";
import "swiper/css";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import Button from "@components/atoms/Button";
import Icon from "@components/atoms/Icon";
import Image from "@components/atoms/Image";

import useDominantColor from "@hooks/useDominantColor";

import { IconName } from "@const/enum";

interface IProps {
  images: string[];
}

function ImageSlider({ images }: IProps) {
  const [showDetail, setShowDetail] = useState(false);

  useDominantColor(images[0]);

  return (
    <div className="bg-tertiary pc:col-start-2 pc:row-start-1 col-start-1 row-start-2 aspect-4/5 w-full rounded-md">
      {images.length ? (
        <Swiper
          className="bg-tertiary pc:rounded-md aspect-4/5 rounded-sm"
          loop
          modules={[Pagination, Navigation]}
          navigation
          onSliderMove={() => {
            document.documentElement.style.overflow = "hidden";
          }}
          onTouchEnd={() => {
            document.documentElement.style.overflow = "auto";
          }}
          onUpdate={(swiper) => {
            swiper.slideTo(0, 0);
          }}
          pagination={{ clickable: true }}
          slidesPerView={1}
          spaceBetween={0}
        >
          {images.map((image, index) => (
            <SwiperSlide key={image} virtualIndex={index}>
              <div className="aspect-4/5 overflow-hidden">
                <Image alt={`product-image-${index + 1}`} isLazy={index <= 0} src={image} />
              </div>
            </SwiperSlide>
          ))}
          <Button
            className="absolute bottom-2.5 left-2.5 z-20"
            onClick={() => {
              setShowDetail(true);
            }}
            styleType="secondary"
            variant="containedIcon"
          >
            <Icon alt="plus_100" name={IconName.Plus_100} />
          </Button>
        </Swiper>
      ) : (
        // 빈 이미지 컴포넌트
        <Image />
      )}

      {showDetail ? (
        <div
          className="fixed top-0 left-0 z-30 size-full cursor-zoom-out overflow-y-auto bg-white"
          onClick={() => {
            setShowDetail(false);
          }}
          role="presentation"
        >
          <div className="flex flex-col gap-1">
            {images.map((image) => (
              <div className="bg-tertiary aspect-4/5 overflow-hidden" key={uniqueId()}>
                <Image className="w-full" src={image} />
              </div>
            ))}
          </div>
          <Button
            className="bg-tuneGrey-200 fixed top-5 right-5 z-20 flex items-center justify-center rounded-sm px-3 py-2 xl:top-10 xl:right-10"
            onClick={() => {
              setShowDetail(false);
            }}
            type="button"
            variant="icon"
          >
            <Icon alt="close_100" name={IconName.Close_100} />
          </Button>
        </div>
      ) : null}
    </div>
  );
}

export default ImageSlider;
